export default __webpack_public_path__ + "static/media/bridgeTo.a9989204.svg";